import { ColocFormData, ValidationErrors } from './types';

export const validateForm = (
  formData: ColocFormData,
  t: (key: string) => string
): ValidationErrors => {
  const errors: ValidationErrors = {};

  if (!formData.colocFirstName.trim()) {
    errors.colocFirstName = t(
      'js.features.admin.contracts.add_coloc_form.validation.first_name_required'
    );
  }

  if (!formData.colocLastName.trim()) {
    errors.colocLastName = t(
      'js.features.admin.contracts.add_coloc_form.validation.last_name_required'
    );
  }

  if (!formData.colocEmail.trim()) {
    errors.colocEmail = t('js.features.admin.contracts.add_coloc_form.validation.email_required');
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.colocEmail)) {
    errors.colocEmail = t('js.features.admin.contracts.add_coloc_form.validation.email_invalid');
  }

  if (!formData.colocMobileNumber.trim()) {
    errors.colocMobileNumber = t(
      'js.features.admin.contracts.add_coloc_form.validation.mobile_required'
    );
  }

  if (!formData.colocBirthday) {
    errors.colocBirthday = t(
      'js.features.admin.contracts.add_coloc_form.validation.birthday_required'
    );
  }

  if (!formData.colocBirthplace.trim()) {
    errors.colocBirthplace = t(
      'js.features.admin.contracts.add_coloc_form.validation.birthplace_required'
    );
  }

  if (isNaN(Number(formData.colocId))) {
    errors.colocId = t('js.features.admin.contracts.add_coloc_form.validation.coloc_id_invalid');
  }

  if (!formData.securityDepositAmount.trim()) {
    errors.securityDepositAmount = t(
      'js.features.admin.contracts.add_coloc_form.validation.deposit_amount_required'
    );
  } else if (isNaN(Number(formData.securityDepositAmount))) {
    errors.securityDepositAmount = t(
      'js.features.admin.contracts.add_coloc_form.validation.deposit_amount_invalid'
    );
  }

  if (!formData.securityDepositAmountPaid.trim()) {
    errors.securityDepositAmountPaid = t(
      'js.features.admin.contracts.add_coloc_form.validation.deposit_paid_required'
    );
  } else if (isNaN(Number(formData.securityDepositAmountPaid))) {
    errors.securityDepositAmountPaid = t(
      'js.features.admin.contracts.add_coloc_form.validation.deposit_paid_invalid'
    );
  }

  return errors;
};
